export default __webpack_public_path__ + "static/media/map-marker-alt-solid.56d4791d.svg";